import React from 'react';
import ReactDOM from 'react-dom/client';
import ky from 'ky';
import './index.css';
import log from './logger';

import App from './App';
import reportWebVitals from './reportWebVitals';
import pkg from '../package.json';

ky.get('StreamingAssets/SYSTEM/buildInfo.json')
    .json()
    .then((info) => {
        log.info('Unity Build info', info);
        log.info(`React app version: "${pkg.version}"`);
    })
    .catch((err) => log.error(err));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
